"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MultiLineTooltipTitle = exports.MultiLineTooltipSubtext = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _useTheme = require("../../../theme/utils/useTheme");
var _MultilineTooltipDeprecatedStyled = require("../styled/MultilineTooltipDeprecatedStyled");
/**
 * @deprecated Please use TooltipTitle inside a TooltipBody instead. This gives the Tooltip
 * component more flexibility in its composition.
 */
const MultiLineTooltipTitle = /*#__PURE__*/(0, _react.forwardRef)((_ref, ref) => {
  let {
    children,
    ...rest
  } = _ref;
  const {
    key
  } = (0, _useTheme.useTheme)();
  const themeMode = key;
  return /*#__PURE__*/_react.default.createElement(_MultilineTooltipDeprecatedStyled.MultiLineTooltipTitleStyled, (0, _extends2.default)({}, rest, {
    themeMode: themeMode,
    ref: ref
  }), children);
});
exports.MultiLineTooltipTitle = MultiLineTooltipTitle;
MultiLineTooltipTitle.displayName = "MultiLineTooltipTitle";

/**
 * @deprecated Please use TooltipMultilineText inside a TooltipBody instead. This gives the Tooltip
 * component more flexibility in its composition.
 */
const MultiLineTooltipSubtext = /*#__PURE__*/(0, _react.forwardRef)((_ref2, ref) => {
  let {
    children,
    ...rest
  } = _ref2;
  const {
    key
  } = (0, _useTheme.useTheme)();
  const themeMode = key;
  return /*#__PURE__*/_react.default.createElement(_MultilineTooltipDeprecatedStyled.MultiLineTooltipSubtextStyled, (0, _extends2.default)({}, rest, {
    themeMode: themeMode,
    ref: ref
  }), children);
});
exports.MultiLineTooltipSubtext = MultiLineTooltipSubtext;
MultiLineTooltipSubtext.displayName = "MultiLineTooltipSubtext";
//# sourceMappingURL=MultilineTooltipDeprecated.js.map